import * as notifications from '@debbie/cortex/dist/notifications.js';
import { UnauthorizedError } from '@debbie/common/dist/util/errors.js';
export const errorNotification = (lang, err, action, identifier) => {
    const errorTextMap = {
        any: lang.misc.errorPerforming,
        delete: lang.misc.errorDeleting,
        update: lang.misc.errorUpdating,
        create: lang.misc.errorCreating,
    };
    const errorMessage = `${errorTextMap[action]} ${identifier}`;
    if (err instanceof UnauthorizedError) {
        notifications.notification({
            title: lang.misc.error,
            theme: 'error',
            subtitle: `${lang.errors.unauthorizedError}:\n${errorMessage}`,
        });
        return;
    }
    notifications.notification({
        title: lang.misc.error,
        theme: 'error',
        subtitle: errorMessage,
    });
};
//# sourceMappingURL=errors.js.map